module.exports = __webpack_public_path__ + "img/octagon-fill.cc876f4b.svg";